var map = {
	"./icon-10-12-lock.svg": 421,
	"./icon-12-15-private.svg": 422,
	"./icon-12-16-open-lock.svg": 423,
	"./icon-12-public.svg": 424,
	"./icon-14-check.svg": 789,
	"./icon-14-minus.svg": 790,
	"./icon-14-plus.svg": 134,
	"./icon-16-19-delete.svg": 425,
	"./icon-16-20-gray-delete.svg": 426,
	"./icon-16-enter.svg": 791,
	"./icon-16-ready.svg": 427,
	"./icon-18-timer.svg": 428,
	"./icon-18-user.svg": 429,
	"./icon-19-12-share.svg": 216,
	"./icon-20-board.svg": 792,
	"./icon-20-close.svg": 793,
	"./icon-20-create.svg": 794,
	"./icon-20-donate.svg": 795,
	"./icon-20-download.svg": 796,
	"./icon-20-edit.svg": 797,
	"./icon-20-expand.svg": 430,
	"./icon-20-export.svg": 296,
	"./icon-20-feedback.svg": 798,
	"./icon-20-fix.svg": 799,
	"./icon-20-info.svg": 800,
	"./icon-20-logout.svg": 801,
	"./icon-20-maximize.svg": 802,
	"./icon-20-search.svg": 803,
	"./icon-20-send-button.svg": 804,
	"./icon-20-settings.svg": 431,
	"./icon-20-share.svg": 805,
	"./icon-20-stack-active.svg": 806,
	"./icon-20-stack-enabled.svg": 807,
	"./icon-20-stack-hover.svg": 808,
	"./icon-20-timer.svg": 809,
	"./icon-20-trash.svg": 810,
	"./icon-24-search.svg": 432,
	"./icon-32-add.svg": 811,
	"./icon-32-arrow-left-alt.svg": 812,
	"./icon-32-arrow-left.svg": 813,
	"./icon-32-arrow-right-alt.svg": 814,
	"./icon-32-arrow-right.svg": 815,
	"./icon-32-circle.svg": 816,
	"./icon-32-close.svg": 817,
	"./icon-32-key-down.svg": 818,
	"./icon-32-key-esc.svg": 819,
	"./icon-32-key-up.svg": 820,
	"./icon-32-more-new.svg": 821,
	"./icon-32-more.svg": 822,
	"./icon-32-overview.svg": 823,
	"./icon-44-selection-circle-grey.svg": 824,
	"./icon-44-selection-circle.svg": 825,
	"./icon-48-chevron-left.svg": 826,
	"./icon-48-chevron-right.svg": 827,
	"./icon-48-close.svg": 828,
	"./icon-5-3-checked.svg": 433,
	"./icon-6-12-arrow.svg": 297,
	"./logo-retroteam.svg": 829,
	"./logo.svg": 830,
	"./logo_retroteam.svg": 831,
	"./phase1-01-create.svg": 832,
	"./phase1-02-communicate.svg": 833,
	"./phase1-03-combine.svg": 834,
	"./phase2-01-vote.svg": 835,
	"./phase3-01-discuss.svg": 836,
	"./phase3-02-define.svg": 837,
	"./retroteam-logo.svg": 838,
	"./social-icon-facebook.svg": 839,
	"./social-icon-instagram.svg": 840,
	"./social-icon-twitter.svg": 841,
	"./visual-idea-retroteam.svg": 842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 788;